module.exports = __webpack_public_path__ + "img/cloth_g1_shirt_01.77e8c384.svg";